import { useEffect, useState } from 'react';
import { streamingStatsVisible } from '../utils/streamingStats';

export default function useStreamingStats(state, mode, ready) {
    const [now, setNow] = useState(Date.now);
    const [lastScoreAt, setLastScoreAt] = useState(Date.now);
    useEffect(() => {
        setLastScoreAt(Date.now());
        setNow(Date.now());
    }, [state.player1Score, state.player2Score, state.currentBreakPoints, state.currentPlayer,
        state.currentFrame, state.player1FramesWon, state.player2FramesWon, ready]);
    useEffect(() => {
        if (!ready) return;
        const timer = setInterval(() => setNow(Date.now()), 250);
        return () => clearInterval(timer);
    }, [ready]);
    return streamingStatsVisible({ state, mode, now, lastScoreAt, ready });
}
